import { useCallback, useMemo, useState } from 'react';

type Target = 'task' | 'list';
export type OpenDeleteTasksModalHandlerType = (target?: Target) => void;

export const useDeleteTasksModal = () => {
  const [target, setTarget] = useState<Target>('task');
  const [isOpenDeleteTasksModal, setIsOpenDeleteTasksModal] = useState(false);

  const openDeleteTasksModal: OpenDeleteTasksModalHandlerType = useCallback(
    (target = 'task') => {
      setTarget(target);
      setIsOpenDeleteTasksModal(true);
    },
    []
  );

  const closeDeleteTaskModal = useCallback(() => {
    setIsOpenDeleteTasksModal(false);
  }, []);

  const deleteModalTitle = useMemo(
    () => `Удаление задач${target === 'task' ? 'и' : ''}`,
    [target]
  );

  const deleteModalSubtitle = useMemo(
    () =>
      `Вы уверены, что хотите удалить ${
        target === 'task' ? 'задачу' : 'выбранные задачи'
      }?`,
    [target]
  );

  return {
    isOpenDeleteTasksModal,
    openDeleteTasksModal,
    closeDeleteTaskModal,
    deleteModalTitle,
    deleteModalSubtitle,
    setIsOpenDeleteTasksModal,
    target,
  };
};
